import React from "react";
import {FormattedMessage} from "react-intl";
import RadioButtonGroup from "../../RadioButtonGroup/RadioButtonGroup";
import {Link} from 'react-router-dom';

let materialDetails = [
    {
        id: 0,
        checked: true,
        name: "materialDetails",
        text: <FormattedMessage id="app.pcb-quotation.pcb-material-details-standard-tg"
                                defaultMessage="FR4 - Standard Tg 140C" description=""/>
    }
];

const MaterialDetails = (props) => {

    let pcbMaterialDetails = materialDetails.map((item) => {
        item.checked = (item.id === props.selectedId);
        return item;
    });

    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="pcb-details-div">
                    <div className="col-md-3 text-right content-item-heading">
                        <FormattedMessage id="app.pcb-quotation.pcb-material-details"
                                          defaultMessage="Material Details"
                                          description=""
                        />
                        &nbsp;&nbsp;
                        <Link id="mtrlDetail-qLink"
                            to={{pathname:"https://kitcutlabo.com/pcb-material/"}} target="_self"
                            className="glyphicon glyphicon-question-sign question-link"></Link>
                    </div>
                    <div className="btn-group col-md-9 pcb-details-div-items">
                        <RadioButtonGroup data={pcbMaterialDetails} getParams={props.setPCBParams}/>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default MaterialDetails;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/MaterialDetails.js